var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amis"},[_c('el-switch',{attrs:{"active-text":"预览"},model:{value:(_vm.preview),callback:function ($$v) {_vm.preview=$$v},expression:"preview"}}),_c('div',{ref:"renderBox",staticClass:"content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }